import * as React from 'react';
import PageContainer from "@components/PageContainer";
import Button from "@layout/buttons/Button";
import LineButton from "@layout/buttons/LineButton";
import PageTitle from "@layout/PageTitle";
import Block from "@layout/Block";
import Font from "@layout/Font";
import { Link } from 'react-router-dom';
import './index.scss';
import { Blog } from '@store/index';
import Dreff from '@utils/Dreff';
import queryString = require('query-string');
import { Location } from 'history';

interface OwnProps { 
    blogs: Blog[];
    technologies: string[];
    location: Location
}

interface Props { }

class BlogPage extends React.Component<Props & OwnProps> {
    public componentDidMount() {

        this.getBlogFiltered().map((blog: Blog, index: number) => {
            Dreff({ init: `.section-${index}`, clipPath: blog.clipPath });
        })
    }

    private inQueryString = (technology: string | string[]): boolean => {
        let tech = this.getTechQueryString();

        return technology.indexOf(tech) > -1;
    }

    private getTechQueryString = (): string => {
        return queryString.parse(this.props.location.search).tech as string;
    }

    private getBlogFiltered = (): Blog[] => {
        if (!this.getTechQueryString()) {
            return this.props.blogs;
        }

        return this.props.blogs.filter((blog: Blog) => this.inQueryString(blog.tech))
    }

    render(): JSX.Element {
        const { technologies } = this.props;

        return (
            <PageContainer>
                <Block indent="10">
                    <PageTitle>
                        Welcome to my Blog
                    </PageTitle>
                </Block>
                <Block indent="20">
                    <Font font="secondary">
                        Blog items written in my spare time
                    </Font>
                </Block>

                {/* <Block indent="15">
                    <div className="blog-technologies">
                        {
                            technologies.map((technology: string, index: number) => {
                                const selected = this.inQueryString(technology);

                                return (
                                    <Link
                                        key={`tech-btn-${index}`}
                                        to={(selected) ? '/blog?' : `/blog?tech=${technology}`}
                                    >
                                        <Button selected={selected}>{technology}</Button>
                                    </Link>
                                )
                            })
                        }
                    </div>
                </Block> */}

                <div className="grid">
                    {
                        this.getBlogFiltered().map((blog: Blog, index: number) => {
                            return (
                                <div className="grid-6" key={`porfilio-${index}`}>
                                    <Link className="blog-link" to={`/blog/${blog.slug}`}>
                                        <div className="blog">
                                            <div className={`img-container section-${index}`}>
                                                <img src={blog.cover} />
                                            </div>
                                            <div className="description-container">
                                                <div className="text">
                                                    <Block indent="10">
                                                        <div className="name">{ blog.name }</div>
                                                    </Block>
                                                    <div className="description">{ blog.description }</div>
                                                </div>
                                                <div className="tags">
                                                    {
                                                        blog.tech.map((tech: string, index: number) => (
                                                            <LineButton key={`btn-${index}`}>{tech}</LineButton>
                                                        ))
                                                    }
                                                </div>
                                            </div>
                                        </div> 
                                    </Link>   
                                </div>
                            )
                        })
                    }
                </div>
            </PageContainer>
        );
    }
}

export default BlogPage;


// WEBPACK FOOTER //
// ./src/components/Blog/index.tsx